/**
 * @author: shixl 拷贝
 * @create: 2019/12/19 4:38 下午
 * @version: 1.0
 * @email: sunc@oceansoft.com
 */
export const forEachObj = data => {
  for (let key in data) {
    if (typeof(data[key]) === "string") {
      data[key] = data[key].trim()
    }
    if (typeof(data[key]) === "object") {
      forEachObj(data[key])
    }
  }
}
